'use client';

import React from 'react';

import { School } from 'types/collections';

import { Header, InfoContainer } from '@components/Common';
import { ClickableAddress } from '@components/Listing/components/ClickableAddress';

import { getSchoolAddress, getSchoolName } from '@utils/helpers/schoolListingHelpers';

interface SchoolHeaderProps {
  schoolProfile: School | null;
}

/**
 * Render address and school name for listing
 */

export const SchoolHeader: React.FC<SchoolHeaderProps> = ({ schoolProfile }) => {
  const renderAddress = () => {
    const address = getSchoolAddress(schoolProfile);
    if (!address) return null;

    return <ClickableAddress name={getSchoolName(schoolProfile)} address={address} />;
  };

  return (
    <>
      <InfoContainer>
        <Header>{getSchoolName(schoolProfile)}</Header>
        {renderAddress()}
      </InfoContainer>
    </>
  );
};
